import { action, override } from 'mobx';
import { AddressCompletionService } from 'common/data';
import { BaseStore } from 'core/stores';
import _ from 'lodash';

class AddressCompletionStore extends BaseStore {
	constructor(rootStore) {
		super(new AddressCompletionService(rootStore.app.baasic.apiClient));
	}

	@action
	findAutofill = async addressSearch => {
		const response = await this.service.find(addressSearch);
		this.response = response.data;
		return response.data;
	};

	@action
	verifyAddress = async address => {
		const response = await this.service.verify(address);
		this.response = response.data;
		return response.data;
	};
}

export default AddressCompletionStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/AddressCompletionStore.js